export default __webpack_public_path__ + "static/logo-30acce7db7934e04ff99d7c460e00046.png";